if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
        });
      }

      select(tab, focus = false) {
        this.tabs.forEach((other) => {
          const selected = other === tab;
          other.setAttribute('aria-selected', String(selected));
          other.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(other.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        if (focus) tab.focus();
      }

      onKeydown(event, tab) {
        const index = this.tabs.indexOf(tab);
        let next = null;
        if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
        if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
        if (event.key === 'Home') next = this.tabs[0];
        if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
        if (next) {
          event.preventDefault();
          this.select(next, true);
        }
      }
    }
  );
}
